import React from 'react';
import { motion } from 'framer-motion';

export default function PrivacyPolicy() {
  return (
    <div className="pt-32 pb-24 bg-stone-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-stone-100"
        >
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4">Privacy Policy</h1>
          <p className="text-stone-500 mb-8">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <div className="space-y-8 text-stone-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">1. Introduction</h2>
              <p>
                Land Quick ("we," "our," or "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, Land Quick, or engage with our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">2. Information We Collect</h2>
              <p className="mb-2">We may collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our services, including:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Contact Data:</strong> Name, email address, and phone number.</li>
                <li><strong>Property Data:</strong> State, and other property details you provide during communication.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">3. How We Use Your Information</h2>
              <p className="mb-2">We use the personal information collected to:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Evaluate your property and formulate a potential cash offer.</li>
                <li>Communicate with you regarding your property and our services.</li>
                <li>Facilitate the sale and closing process if an agreement is reached.</li>
                <li>Improve our website and customer service.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">4. Information Sharing</h2>
              <p>
                We do not sell, rent, or trade your personal information to third parties. We may share your information with trusted third parties who assist us in operating our business, such as title companies, escrow agents, and legal advisors, as long as those parties agree to keep this information confidential. We may also release information when required to comply with the law.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">5. Data Security</h2>
              <p>
                We implement a variety of security measures to maintain the safety of your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">6. Governing Law</h2>
              <p>
                This Privacy Policy and our privacy practices are governed by the laws of the State of Alabama, without regard to its conflict of law principles.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-900 mb-3">7. Contact Us</h2>
              <p>
                If you have questions or comments about this Privacy Policy, please contact us at:<br /><br />
                <strong>Land Quick</strong><br />
                Email: stu@landquick.net
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}